import sensors from 'sa-sdk-javascript'

import { getCookieAuthInfo, getGlobalConfig, getOrCreateSensorsAnonymousId, isPWA } from './src/utils'

const ENVIRONMENT = getGlobalConfig().VITE_ENVIRONMENT

const VITE_SENSORS_TRACK_URL = getGlobalConfig().VITE_SENSORS_TRACK_URL

const productionMode = ENVIRONMENT === 'prod'

const isPWAPage = isPWA()

const isLoggedIn = () => {
  const { token, tokenExpire } = getCookieAuthInfo('token', 'tokenExpire')
  const expireTimestamp = Number(tokenExpire)

  return Boolean(token && !Number.isNaN(expireTimestamp) && expireTimestamp > Math.floor(Date.now() / 1000))
}

sensors.init({
  server_url: VITE_SENSORS_TRACK_URL,
  is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
  use_client_time: true,
  send_type: 'beacon',
  show_log: !productionMode,
  heatmap: {
    //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: 'default',
    //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: 'not_collect',
    // 配置WebClick触发的元素
    collect_tags: {
      div: {
        max_level: 2, // 嵌套层级
      },
      img: true,
    },
  },
  cross_subdomain: false,
})

// 注册公共属性
const anonymousId = getOrCreateSensorsAnonymousId()
if (!isLoggedIn() && anonymousId) {
  sensors.identify(anonymousId)
}

sensors.registerPage({
  platform: 'wap',
  referrer: document.referrer,
  isPWAPage,
})

sensors.use('PageLeave', {})

sensors.quick('autoTrack') //用于采集 $pageview 事件。
